import ApiErrorHandler from '../service/ApiErrorHandler';
import MessageDispatcher from '../service/MessageDispatcher';
import OtpRecoveryCodeWebApi from '../service/persistent/OtpRecoveryCodeWebApi';

class OtpRecoveryCodeUsecase {
  private apiErrorHandler: ApiErrorHandler;
  private otpRecoveryCodeWebApi: OtpRecoveryCodeWebApi;
  private messageDispatcher: MessageDispatcher;

  constructor({
    apiErrorHandler,
    otpRecoveryCodeWebApi,
    messageDispatcher,
  }: {
    apiErrorHandler: ApiErrorHandler;
    otpRecoveryCodeWebApi: OtpRecoveryCodeWebApi;
    messageDispatcher: MessageDispatcher;
  }) {
    this.apiErrorHandler = apiErrorHandler;
    this.otpRecoveryCodeWebApi = otpRecoveryCodeWebApi;
    this.messageDispatcher = messageDispatcher;
  }

  public get = async (): Promise<string[]> => {
    try {
      const result = await this.otpRecoveryCodeWebApi.get();
      return result;
    } catch (err) {
      this.apiErrorHandler.handle(err);
      return Promise.reject();
    }
  };

  public regenerate = async (): Promise<string[]> => {
    try {
      const result = await this.otpRecoveryCodeWebApi.regenerate();
      this.messageDispatcher.notifyUnimportant('user_setting.login.otp.recovery_codes_regenerated');
      return result;
    } catch (err) {
      this.apiErrorHandler.handle(err);
      return Promise.reject();
    }
  };
}

export default OtpRecoveryCodeUsecase;
